import { useApi } from '@/api';
import { Banner, KpiCard, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import BufferAssetDistribution from './BufferAssetDistribution';
import HistoricTabs from './HistoricTabs';
export default function AggregateBufferPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useApi({
    url: '/buffer/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page title="Aggregate Capital Buffer">
        <Flex gap={['m', 's']} flexDirection={'column'}>
          <Banner>
            <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
              <Heading size="2">About the Sky Protocol Capital Buffer</Heading>
              <br />
              Breakdown of Sky Protocol&apos;s Aggregate Capital Buffer, which
              is composed of the USDS holdings of the Sky Core Treasury and the
              treasury of the Star Agents.
            </Box>
          </Banner>
          <KpiCard
            title="Aggregate Capital Buffer"
            data={data}
            field="aggregate_capital_buffer"
            options={{
              currency: 'USD',
              notation: 'standard'
            }}
          />
        </Flex>

        <HistoricTabs />
        <BufferAssetDistribution />
      </Page>
    );
  }
  return null;
}
